import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function TechnologySection() {
  const techSpecs = [
  {
    id: 'spec_thickness',
    icon: 'ShieldCheckIcon',
    title: 'GROSOR PREMIUM',
    value: '8.0 mil',
    description: 'Film de protección de grado militar'
  },
  {
    id: 'spec_healing',
    icon: 'SparklesIcon',
    title: 'AUTO-REGENERACIÓN',
    value: 'Con calor',
    description: 'Elimina rayones menores automáticamente'
  },
  {
    id: 'spec_warranty',
    icon: 'DocumentCheckIcon',
    title: 'GARANTÍA',
    value: '10 años',
    description: 'Respaldo del fabricante incluido'
  },
  {
    id: 'spec_clarity',
    icon: 'EyeIcon',
    title: 'CLARIDAD ÓPTICA',
    value: '99.9%',
    description: 'Completamente invisible al ojo'
  }];


  const certifications = [
  { id: 'cert_1', name: 'XPEL Certified', logo: 'CheckBadgeIcon' },
  { id: 'cert_2', name: '3M Authorized', logo: 'ShieldCheckIcon' },
  { id: 'cert_3', name: 'SunTek Elite', logo: 'StarIcon' }];


  return (
    <section className="py-32 px-6 lg:px-12 bg-black" id="technology">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-primary font-heading text-sm tracking-[0.3em] mb-4 block">
            TECNOLOGÍA PREMIUM
          </span>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white mb-6 tracking-tight">
            TECNOLOGÍA DE
            <br />
            <span className="text-gradient-red">COMPETICIÓN</span>
          </h2>
        </div>

        {/* Split Layout */}
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: 3D Product Visualization */}
          <div className="relative">
            <div className="relative aspect-square rounded-[32px] overflow-hidden border border-white/10 bg-gradient-to-br from-card via-secondary to-card">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1cd6d4c4e-1770188729371.png"
                alt="Close-up of premium PPF film showing self-healing technology and crystal clarity"
                className="w-full h-full object-cover mix-blend-overlay opacity-40" />

              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-32 h-32 rounded-full bg-primary/20 border-2 border-primary flex items-center justify-center mb-6 animate-pulse-glow">
                    <Icon
                      name="ShieldCheckIcon"
                      size={64}
                      variant="solid"
                      className="text-primary" />

                  </div>
                  <div className="text-white font-heading text-2xl tracking-wider">
                    PPF PREMIUM
                  </div>
                  <div className="text-white/60 text-sm mt-2">
                    Protección Invisible
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Specs */}
            <div className="absolute -top-8 -right-8 glass-card p-6 rounded-[24px] animate-float">
              <div className="text-primary font-heading text-3xl mb-1">8.0</div>
              <div className="text-white/60 text-xs tracking-wider">
                MIL THICKNESS
              </div>
            </div>
            <div className="absolute -bottom-8 -left-8 glass-card p-6 rounded-[24px] animate-float delay-200">
              <div className="text-primary font-heading text-3xl mb-1">10</div>
              <div className="text-white/60 text-xs tracking-wider">
                AÑOS GARANTÍA
              </div>
            </div>
          </div>

          {/* Right: Technical Specs */}
          <div className="space-y-8">
            {techSpecs.map((spec, index) =>
            <div
              key={spec.id}
              className="glass-card p-6 rounded-[24px] hover:bg-white/10 transition-all duration-300 animate-slide-in-right"
              style={{ animationDelay: `${index * 100}ms` }}>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0">
                    <Icon
                    name={spec.icon as any}
                    size={24}
                    variant="outline"
                    className="text-primary" />

                  </div>
                  <div className="flex-1">
                    <div className="flex items-baseline gap-3 mb-2">
                      <h3 className="font-heading text-sm text-white tracking-wider">
                        {spec.title}
                      </h3>
                      <span className="text-primary font-heading text-xl">
                        {spec.value}
                      </span>
                    </div>
                    <p className="text-white/60 text-sm leading-relaxed">
                      {spec.description}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Certifications */}
            <div className="pt-8 border-t border-white/10">
              <h4 className="font-heading text-sm text-white tracking-wider mb-6">
                CERTIFICACIONES OFICIALES
              </h4>
              <div className="flex flex-wrap gap-4">
                {certifications.map((cert) =>
                <div
                  key={cert.id}
                  className="glass-card px-6 py-3 rounded-full flex items-center gap-2">

                    <Icon
                    name={cert.logo as any}
                    size={20}
                    variant="solid"
                    className="text-primary" />

                    <span className="text-white/80 text-sm font-medium">
                      {cert.name}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}